import { push, goBack } from "connected-react-router";
import { setIsLoading } from "./commonActions";
// eslint-disable-next-line import/no-unresolved
import { reverse } from "named-urls";

let goToRoute = function (path, params = {}, query = null) {
	return (dispatch) => {
		let routePath = reverse(path, params);
		if (query) {
			let search = new URLSearchParams(query);
			routePath = `${routePath}?${search.toString()}`;
		}
		dispatch(setIsLoading(false));
		dispatch(push(routePath));
	};
};

let setQuery = function (key, value) {
	return (dispatch, getState) => {
		let state = getState();
		let search = state.router.location.search;
		let searchParams = new URLSearchParams(search);
		searchParams.set(key, value);
		dispatch(setIsLoading(false));
		dispatch(
			push({
				search: searchParams.toString(),
			})
		);
	};
};

let setQueries = function (arr) {
	return (dispatch) => {
		let searchParams = new URLSearchParams();
		arr.forEach((i) => {
			searchParams.set(i.key, i.value);
		});
		dispatch(setIsLoading(false));
		dispatch(
			push({
				search: searchParams.toString(),
			})
		);
	};
};

let back = function () {
	return (dispatch) => {
		dispatch(setIsLoading(false));
		dispatch(goBack());
	};
};

export { goToRoute, setQuery, setQueries, back };
